import { render } from "./LibraryOverview.vue?vue&type=template&id=18fce292&ts=true"
import script from "./LibraryOverview.vue?vue&type=script&lang=ts"
export * from "./LibraryOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__